(ns frontend.view.components.power-search.event
  (:require
   [common.opensearch.entity-indices :as entity-indices]
   [common.opensearch.fields :as cos]
   [frontend.actions.account :as account-actions]
   [frontend.controller.websocket.event :as ws]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.page-components.navigation.events :as new-navigation-events]
   [frontend.view.components.power-search.sub :as sub]
   [re-frame.core :as rf]))

;; TODO: Keyboard shortcut to open universal search? Algolia and Tailwind use Cmd + K
;; TODO: Search again when returning to main view if the search query has changed while in single entity type view

(rf/reg-event-fx
 ::open-type-view
 (fn [{:keys [db] :as cofx} [_ entity-type]]
   {:db (-> db
            (assoc ::sub/type-view-entity-type entity-type
                   ::sub/show-loading-text? true
                   ::sub/from-index 0))
    :fx [[:dispatch [::search-type-view false]]]}))

(rf/reg-event-fx
 ::load-more
 (fn [{:keys [db] :as cofx} [_]]
   {:db (-> db
            (assoc ::sub/from-index (count (::sub/type-view-hits db))))
    :fx [[:dispatch [::search-type-view true]]]}))

(rf/reg-event-fx
 ::close-type-view
 (fn [{:keys [db] :as cofx} [_ entity-type]]
    ;; TODO: Search again if query has changed
   {:db (-> (apply dissoc
                   db
                   [::sub/show-loading-text?
                    ::sub/type-view-hits
                    ::sub/type-view-entity-type
                    ::sub/main-view-reload-on-type-view-close?
                    (when (::sub/main-view-reload-on-type-view-close? db)
                      ::sub/main-view-hits-by-entity-type)])
            (assoc ::sub/show-loading-text? true))
    :fx [(when (::sub/main-view-reload-on-type-view-close? db)
           [:dispatch [::search-main-view]])]}))

(rf/reg-event-fx
 ::toggle-open
 (fn [{:keys [db] :as cofx} [_ args]]
   {:db (update db ::sub/open? not)
    :fx [[:dispatch [::new-navigation-events/close-modal]]]}))

(rf/reg-event-fx
 ::on-test-response
 (fn [{:keys [db] :as cofx} [_ {:keys [body] :as args}]]
   (js/console.log "test response" body)
   {}))

(rf/reg-event-fx
 ::on-test-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "test failed")
   {}))

(rf/reg-event-fx
 ::close
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "::close")
   {:db (apply dissoc
               db
               [::sub/open?
                ::sub/show-loading-text?
                ::sub/type-view-hits
                ::sub/type-view-entity-type
                ::sub/main-view-reload-on-type-view-close?
                ::sub/main-view-hits-by-entity-type
                ::sub/main-view-loaded-query
                ::sub/type-view-loaded-query
                ::sub/query])}))

(rf/reg-event-fx
 ::esc
 (fn [{:keys [db] :as cofx} [_ args]]
   {:fx [[:dispatch [::close]]]}))

(rf/reg-event-fx
 ::select-hit
 (fn [{:keys [db] :as cofx} [_ hit]]
   (let [result (cos/hit->id-type-title hit)]
     (routing/set-view! [(:entity/type result) :id (:db/id result)])
     {:fx [[:dispatch [::new-navigation-events/close-modal]]
           [:dispatch [::close]]
           [:dispatch [::add-recent-result-and-query result (::sub/query db)]]]})))

(rf/reg-event-fx
 ::select-recent-search
 (fn [{:keys [db] :as cofx} [_ search-query]]
   (let [input-element (.getElementById js/document "universalSearchInput")]
     (-> input-element
         .-value
         (set! search-query))
     (.focus input-element))
   {:fx [[:dispatch [::query-change search-query]]
         #_[:dispatch [::bump-recent-result (float id)]]]}))

(rf/reg-event-fx
 ::select-recent-result
 (fn [{:keys [db] :as cofx} [_ entity-type id]]
   (routing/set-view! [entity-type :id id])
   {:fx [[:dispatch [::new-navigation-events/close-modal]]
         [:dispatch [::toggle-open]]
         [:dispatch [::bump-recent-result (float id)]]]}))

;; TODO: 1. Make first result selection respect loading states. 2. Highlight the first result in the UI?
(rf/reg-event-fx
 ::select-first-result
 (fn [{:keys [db] :as cofx} [_ args]]
   (let [first-type-view-result (->> db
                                     ::sub/type-view-hits
                                     (map cos/hit->id-type-title)
                                     (first))
         first-main-view-result (->> db
                                     ::sub/main-view-hits-by-entity-type
                                     (vals)
                                     (flatten)
                                     (map cos/hit->id-type-title)
                                     (first))
         first-recents-list-result nil                     ;; TODO
         first-result (or first-type-view-result
                          first-main-view-result
                          first-recents-list-result)]
     (if-let [first-result-id (:db/id first-result)]
       (do (routing/set-view! [(:entity/type first-result) :id first-result-id])
           {:fx [[:dispatch [::new-navigation-events/close-modal]]
                 [:dispatch [::toggle-open]]
                 [:dispatch [::add-recent-result-and-query first-result (::sub/query db)]]]})
       (js/console.error "Failed to select search first result : " first-main-view-result)))))

(defn get-total-by-entity-type
  [msearch-response]
  (->> msearch-response
       :responses
       (reduce
        (fn [entity-type->total response]
          (let [entity-type (-> response
                                :hits
                                :hits
                                (first)
                                :_source
                                :original
                                :entity/type
                                (keyword))
                total (-> response
                          :hits
                          :total
                          :value)]
            (update entity-type->total entity-type (fnil + 0) total)))
        {})))

(rf/reg-event-fx
 ::on-search-main-view-response
 (fn [{:keys [db] :as cofx} [_ request-query {:keys [body] :as args}]]
   (let [entity-type->hits (->> body
                                :responses
                                (mapcat (comp :hits :hits))
                                (group-by :_id)
                                (map (fn [[id duplicate-hits]]
                                       (first duplicate-hits)))
                                (sort-by :_score >)
                                (group-by (comp keyword :entity/type :original :_source))
                                (sort-by (fn [[entity-type hits]]
                                           (->> hits
                                                (map :_score)
                                                (apply max)))
                                         >))
         entity-type->total (get-total-by-entity-type body)
         query-changed? (not= request-query (::sub/query db))]
     (merge
      {:db (assoc db
                  ::sub/main-view-hits-by-entity-type entity-type->hits
                  ::sub/main-view-hit-totals-by-entity-type entity-type->total
                  ::sub/main-view-loaded-query request-query
                  ::sub/show-loading-text? false)}
      (when query-changed? {:fx [[:dispatch [::search-main-view]]]})))))

(rf/reg-event-fx
 ::on-search-main-view-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "Universal search failed")
   {}))

(def search-entity-types
  #{:entity.type/person
    :entity.type/oppo
    :entity.type/company
    :entity.type/investor
    :entity.type/real-estate
    :entity.type/fof-asset
    :entity.type/other-asset
    :entity.type/fund
    :entity.type/fundraising-opportunity
    :entity.type/sales-opportunity
    :entity.type/exit-opportunity
    :entity.type/holding
    :entity.type/fund-commitment
    :entity.type/kyc-profile})

(defn search-request
  [entity-type query fields pipeline-id]
  (merge {:entity-type        entity-type
          :opensearch-queries [{:multi_match {:fields    fields
                                              :lenient   true
                                              :query     query
                                              :fuzziness "AUTO"}}]
          :sort               [{:_score :desc}]
          :size               5
          :fields             (concat fields ["original.entity/type"])
          :highlight?         true}
         (when pipeline-id {:pipeline-id pipeline-id})))

(rf/reg-event-fx
 ::search-main-view
 (fn [{:keys [db] :as cofx} [_ args]]
   (let [query (::sub/query db)
         fuzzy? (::sub/fuzzy? db)
         body {:id         :search/universal-search
               :body       {:query        query
                            :fuzzy?       fuzzy?
                            :entity-types entity-indices/universal-entity-types}
               :on-success [::on-search-main-view-response query]
               :on-error   [::on-search-main-view-failed]}]
     {::ws/send body})))

(rf/reg-event-fx
 ::on-search-type-view-response
 (fn [{:keys [db] :as cofx} [_ load-more? request-query {:keys [body] :as args}]]
   (js/console.log "OPENSEARCH RESPONSE : " body)
   (let [total-hits (get (get-total-by-entity-type body) (::sub/type-view-entity-type db))
         hits (->> body
                   :responses
                   (mapcat (comp :hits :hits))
                   (sort-by :_score >))
         hits (if load-more?
                (concat (::sub/type-view-hits db)
                        hits)
                hits)
         query (::sub/query db)
         query-changed? (not= request-query query)]
     (merge
      (when-not (empty? query)
        {:db (assoc db
                    ::sub/type-view-hits hits
                    ::sub/type-view-total-hits total-hits
                    ::sub/show-loading-text? false
                    ::sub/type-view-loaded-query request-query)})
      (when query-changed?
        {:fx [[:dispatch [::search-type-view false]]]})))))

(rf/reg-event-fx
 ::on-search-type-view-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "Entity type search failed")
   {}))

(rf/reg-event-fx
 ::search-type-view
 (fn [{:keys [db] :as cofx} [_ load-more?]]
   (let [query (::sub/query db)
         entity-type (::sub/type-view-entity-type db)]
     {::ws/send {:id         :search/universal-search
                 :body       {:query        query
                              :entity-types [entity-type]
                              :from-index   (get db ::sub/from-index 0)}
                 :on-success [::on-search-type-view-response load-more? query]
                 :on-error   [::on-search-type-view-failed]}})))

(rf/reg-event-fx
 ::query-change
 (fn [{:keys [db] :as cofx} [_ query]]
   (-> js/document
       (.getElementById "universalSearchScrollContainer")
       (.scrollTo 0 0))
   (let [main-view-not-loading? (= (::sub/query db) (::sub/main-view-loaded-query db))
         type-view-not-loading? (= (::sub/query db) (::sub/type-view-loaded-query db))
         query-empty? (empty? query)
         type-view? (::sub/type-view-entity-type db)]
     {:db (merge db
                 {::sub/query      (or query "")
                  ::sub/from-index 0}
                 (when (and (not query-empty?) type-view?)
                   {::sub/main-view-reload-on-type-view-close? true})
                 (when (-> db
                           ::sub/query
                           empty?)
                   {::sub/show-loading-text? true}))
      :fx [(if type-view?
             (when type-view-not-loading?
               [:dispatch [::search-type-view false]])
             (when main-view-not-loading?
               [:dispatch [::search-main-view]]))]})))

(rf/reg-event-fx
 ::fuzzy-change
 (fn [{db :db} [_ fuzzy?]]
   (let [main-view-not-loading? (= (::sub/query db) (::sub/main-view-loaded-query db))
         type-view-not-loading? (= (::sub/query db) (::sub/type-view-loaded-query db))
         type-view? (::sub/type-view-entity-type db)]
     {:db (-> db
              (assoc ::sub/fuzzy? fuzzy?))
      :fx [(if type-view?
             (when type-view-not-loading?
               [:dispatch [::search-type-view false]])
             (when main-view-not-loading?
               [:dispatch [::search-main-view]]))]})))

(defn update-view-config
  [path results]
  (account-actions/*->update-view-config
   {:path      path
    :new-value results}
   (fn [] (js/console.log "Saved recent results"))
   (fn [] (js/console.log "Failed to save recent results"))))

;; Add result and query at the same time to avoid a race condition
(rf/reg-event-fx
 ::add-recent-result-and-query
 (fn [{:keys [db] :as cofx} [_ new-result new-query]]
   (let [{:keys [results queries]} (get-in @session/view-config [:universal-search :recents])
         new-results (->> results
                          (remove (fn [result]
                                    (= (:db/id result) (:db/id new-result))))
                          (cons new-result)
                          (take 4))
         new-queries (->> queries
                          (remove (partial = new-query))
                          (cons new-query)
                          (take 4))]
     (account-actions/*->update-view-config
      {:path      [:universal-search :recents]
       :new-value {:results new-results
                   :queries new-queries}}
      (fn [] (js/console.log "Saved recent results"))
      (fn [] (js/console.log "Failed to save recent results")))
     {})))

(rf/reg-event-fx
 ::remove-recent-query
 (fn [{:keys [db] :as cofx} [_ query]]
   (let [new-results (->> (get-in @session/view-config [:universal-search :recents :queries])
                          (remove (partial = query)))]
     (update-view-config [:universal-search :recents :queries] new-results)
     {})))

(rf/reg-event-fx
 ::remove-recent-result
 (fn [{:keys [db] :as cofx} [_ id]]
   (let [new-results (->> (get-in @session/view-config [:universal-search :recents :results])
                          (remove
                           (fn [result]
                             (-> result
                                 :db/id
                                 (= id)))))]
     (update-view-config [:universal-search :recents :results] new-results)
     {})))

(rf/reg-event-fx
 ::bump-recent-result
 (fn [{:keys [db] :as cofx} [_ id]]
   (let [results (get-in @session/view-config [:universal-search :recents :results])
         result (->> results
                     (filter
                      (fn [result]
                        (-> result
                            :db/id
                            (= id))))
                     (first))
         new-results (->> results
                          (remove
                           (fn [result]
                             (-> result
                                 :db/id
                                 (= id))))
                          (cons result))]
     (when result
       (update-view-config [:universal-search :recents :results] new-results))
     {})))

(rf/reg-event-fx
 ::set-input-focused?
 (fn [{:keys [db] :as cofx} [_ focused?]]
   {:db (assoc db ::sub/input-focused? focused?)}))

(rf/reg-event-fx
 ::on-cleanup-deleted-results-response
 (fn [{:keys [db] :as cofx} [_ args]]

   (let [to-keep (->> args
                      :body
                      (filter second)
                      (map first)
                      (set))

         original (get-in @session/view-config [:universal-search :recents :results])
         new-results (->> original
                          (filter (fn [entity]
                                    (some #{(:db/id entity)} to-keep))))]
     (when (not= original new-results)
       (update-view-config [:universal-search :recents :results] new-results))
     {})))

(rf/reg-event-fx
 ::on-cleanup-deleted-results-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "Cleanup recent results failed")
   {}))

(rf/reg-event-fx
 ::cleanup-deleted-results
 (fn [{db :db} _]
   (let [{:keys [results]} (get-in @session/view-config [:universal-search :recents])
         recent-ids (->> results
                         (map :db/id)
                         (set)
                         (vec))]
     {::ws/send {:id         :entity/are-accessible?
                 :body       {:entity-ids recent-ids}
                 :on-success [::on-cleanup-deleted-results-response]
                 :on-error   [::on-cleanup-deleted-results-failed]}})))
